export { default } from "./WritePromptSubmitted";
